module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container pa-3"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [(_vm.message.show) ? _c('v-alert', {
    attrs: {
      "dismissible": "",
      "color": "green darken-3",
      "type": "info"
    }
  }, [_vm._v(_vm._s(_vm.message.text))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('dashboard-activation-data-table', {
    attrs: {
      "AM": _vm.AM,
      "CC": _vm.CC
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('campaign-brief-data-table', {
    attrs: {
      "AM": _vm.AM,
      "CC": _vm.CC
    },
    on: {
      "viewCampaign": _vm.getCampaignDataToView
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('pairing-lineup-data-table', {
    attrs: {
      "AM": _vm.AM,
      "CC": _vm.CC
    },
    on: {
      "viewCampaign": _vm.getCampaignDataToView
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('drafts-data-table', {
    attrs: {
      "AM": _vm.AM,
      "CC": _vm.CC
    },
    on: {
      "viewCampaign": _vm.getCampaignDataToView
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('reporting-data-table', {
    attrs: {
      "AM": _vm.AM,
      "CC": _vm.CC
    },
    on: {
      "viewCampaign": _vm.getCampaignDataToView
    }
  })], 1)], 1), _vm._v(" "), _c('change-password-modal', {
    attrs: {
      "value": _vm.passwordModalDialog
    },
    on: {
      "changePassword": _vm.passwordChanged
    },
    model: {
      value: (_vm.passwordModalDialog),
      callback: function($$v) {
        _vm.passwordModalDialog = $$v
      },
      expression: "passwordModalDialog"
    }
  }), _vm._v(" "), _c('view-campaign-modal', {
    attrs: {
      "modalId": 'view_campaign_modal',
      "value": _vm.viewCampaignModalDialog,
      "campaignData": _vm.viewCampaignData
    },
    model: {
      value: (_vm.viewCampaignModalDialog),
      callback: function($$v) {
        _vm.viewCampaignModalDialog = $$v
      },
      expression: "viewCampaignModalDialog"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b0a27590"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/AMDashboard/index.vue
// module id = 2268
// module chunks = 0